/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Property_Not_FoundInputs */

const cs_public_site_property_not_found = /** @type {(inputs: Public_Site_Property_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemovitost nebyla nalezena nebo již není k dispozici.`)
};

const en_public_site_property_not_found = /** @type {(inputs: Public_Site_Property_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This property was not found or is no longer available.`)
};

/**
* | output |
* | --- |
* | "This property was not found or is no longer available." |
*
* @param {Public_Site_Property_Not_FoundInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_property_not_found = /** @type {((inputs?: Public_Site_Property_Not_FoundInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Property_Not_FoundInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_property_not_found(inputs)
	return cs_public_site_property_not_found(inputs)
});